const BASE_URL = "/portal-attend/attend";

export const getEmployeeLeaveRequestUrl = (screenCode: string) => {
  return `${BASE_URL}/${screenCode}/admin/register-leave`;
};

export const getEmployeeArriveLateRequestUrl = (screenCode: string) => {
  return `${BASE_URL}/${screenCode}/admin/arrive-late`;
};
export const getEmployeeFeedbackRequestUrl = (screenCode: string) => {
  return `${BASE_URL}/${screenCode}/admin/explain`;
};

export const getEmployeeLeaveRequestDetailUrl = (
  screenCode: string,
  requestId: string
) => {
  return `${BASE_URL}/${screenCode}/admin/register-leave/${requestId}`;
};

export const getEmployeeArriveLateRequestDetailUrl = (
  screenCode: string,
  requestId: string
) => {
  return `${BASE_URL}/${screenCode}/admin/arrive-late/${requestId}`;
};

export const getEmployeeFeedbackRequestDetailUrl = (
  screenCode: string,
  requestId: string
) => {
  return `${BASE_URL}/${screenCode}/admin/explain/${requestId}`;
};

export const exportEmployeeLeaveRequestUrl = (screenCode: string) => {
  return `${BASE_URL}/${screenCode}/admin/register-leave/export`;
};
export const exportEmployeeArriveLateRequestUrl = (screenCode: string) => {
  return `${BASE_URL}/${screenCode}/admin/arrive-late/export`;
};
export const exportEmployeeFeedbackRequestUrl = (screenCode: string) => {
  return `${BASE_URL}/${screenCode}/admin/explain/export`;
};

export const exportEmployeeRequestUrl = (screenCode: string, type: string) => {
  return `${BASE_URL}/${screenCode}/admin/${type}/export`;
};
